import React from 'react';
import { Typography } from '@material-ui/core';
import Modal from '../../../components/Modal';
import ModalTitle from '../../../components/ModalTitle';
import styled from 'styled-components';

const ScrollableContent = styled.div`
  max-height: 450px;
  overflow-y: scroll;
  padding: 20px;
  margin-bottom: 20px;
`;

const StyledTypography = styled(Typography)`
  color: #fff1e6 !important;
  font-size: 1rem;
  white-space: pre-line;
  line-height: 1.6;
  margin-bottom: 16px;
`;

const AgreeButton = styled.button`
  background: linear-gradient(90deg, #102D3C 0%, #214E81 20%, #506179 50%, #ED5409 80%, #FFCB67 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 24px;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.2s;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  display: block;

  &:hover {
    opacity: 0.9;
  }
`;

interface TermsModalProps {
  onAgree: () => void;
  onDismiss: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ onAgree, onDismiss }) => {
  const handleAgree = async () => {
    try {
      await onAgree(); // Wait for the agreement transaction
      onDismiss();
    } catch (error) {
      console.error('Error agreeing to terms:', error);
    }
  };

  return (
    <Modal>
      <ModalTitle text="Terms and Conditions" />
      <ScrollableContent>
        <StyledTypography>
          {`While we have taken precautionary measures to protect our users,
it is imperative that you read, understand and agree to the disclaimer below:

- Using our platform may involve financial risk of loss.
- Never invest more than what you can afford to lose.
- Never invest in a HoG Vault with tokens you don't trust.
- Never invest in a HoG Vault with tokens whose rules for minting you don't agree with.
- Ensure the accuracy of the contracts for the tokens in the HoG Vault.
- Ensure the accuracy of the contracts for the HoG Vault and Strategy you are depositing in.
- Check our documentation regularly for additional disclaimers and security assessments.
- ...and of course: DO YOUR OWN RESEARCH!!!

By accepting these terms, you agree that Hand of God, or any parties
affiliated with the deployment and management of these vaults or their attached strategies
are not liable for any financial losses you might incur as a direct or indirect
result of investing in any of the pools on the platform.`}
        </StyledTypography>
      </ScrollableContent>
      <button className='tracking-normal inline-flex whitespace-nowrap backdrop-blur items-center justify-center gap-x-1 py-2 px-6 rounded-full font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 [&>svg]:stroke-[3px] bg-button/[0.16] hover:bg-button/[0.24] transition focus-visible:ring-button text-body' onClick={handleAgree}>
        Agree to Terms
      </button>
    </Modal>
  );
};

export default TermsModal; 